/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    ol: "ol",
    li: "li",
    h3: "h3",
    pre: "pre",
    code: "code",
    h4: "h4"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Webhook"
    }), "\n", _jsxs(_components.p, {
      children: ["According to an article by ", _jsx(_components.a, {
        href: "https://www.niagahoster.co.id/blog/webhook-adalah/",
        children: "niagahoster"
      }), ", a webhook is a method of system-to-system communication, specifically a callback mechanism.\nIn short, the webhook feature allows saweria to communicate with other systems or applications."]
    }), "\n", _jsx(_components.p, {
      children: "Currently, there are two types of webhooks that are natively integrated with saweria:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Discord Webhook"
      }), "\n", _jsx(_components.li, {
        children: "HTTP Webhook"
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Discord Webhook"
    }), "\n", _jsxs(_components.p, {
      children: ["By enabling this feature, saweria will help you “log” support received into your chosen Discord channel. Follow ", _jsx(_components.a, {
        href: "(https://www.instagram.com/p/CjaXpUTPpnw/)",
        children: "this"
      }), " link to set it up."]
    }), "\n", _jsx(_components.h3, {
      children: "HTTP Webhook (Advance)"
    }), "\n", _jsx(_components.p, {
      children: "An HTTP webhook is available if you want to create your own custom integration!"
    }), "\n", _jsx(_components.p, {
      children: "Webhook request from saweria to your system:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "Method: POST\nContent-Type: application/json\nHeader: {\n    Saweria-Callback-Signature: string\n}\n\nBody: {\n    version: string\n    created_at: string\n    id: string\n    amount_raw: integer\n    cut: integer\n    donator_name: string\n    donator_email: string\n    donator_is_user: bool\n    message: string\n}\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "Signature"
    }), "\n", _jsxs(_components.p, {
      children: ["In the header, there is a ", _jsx(_components.code, {
        children: "Saweria-Callback-Signature"
      }), " that can be used to verify that the callback comes from saweria."]
    }), "\n", _jsxs(_components.p, {
      children: ["Code to validate ", _jsx(_components.code, {
        children: "Saweria-Callback-Signature"
      })]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-python",
        children: "# Python code\nimport hmac\n\nsaweria_streaming_key = \"xxxx\"\n\n# from callback, order sensitive!\ncallback_payload = [version, id, amount_raw, donator_name, donator_email]\n\nmsg = \"\".join([v for v in callback_payload]).encode()\n\nsignature = hmac.new(key=saweria_streaming_key.encode(), msg=msg, digestmod=sha256).hexdigest()\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
